import React, { useState, useCallback } from "react";
import styles from "./ProductPoll.module.css";
import NavPanel from "../components/NavPanel";
import ProgressBar from "../components/ProgressBar";
import { useNavigate, useParams } from "react-router-dom";
import NBLogo from "../components/NBLogo";
import Popup from "../components/Popup";

const ProductPoll = () => {
  const navigate = useNavigate();
  const [fortressGrow, setFortressGrow] = useState(false);
  const [prodigyGrow, setProdigyGrow] = useState(false);
  const { athlete } = useParams();
  const [popupVisible, setPopupVisible] = useState(false);

  const sleep = ms => new Promise(r => setTimeout(r, ms));
  
  const onPreviousPageClick = useCallback(() => {
    navigate(`/${athlete}-closet`);
  }, [navigate]);

  const onNextPageClick = useCallback(() => {
    navigate('/fortress');
  }, [navigate]);

  const onClickProdigy = useCallback(async () => {
    setProdigyGrow(true);
    await sleep(1200);
    navigate('/prodigy');
  }, [navigate])


  const onClickFortress = useCallback(async () => {
    setFortressGrow(true);
    await sleep(1200);

    navigate('/fortress');
  }, [navigate])

  const onLogoClick = () => {
    umami?.track('Client Link - NB Logo');
    setPopupVisible(true)
  }

  return (
    <div className={styles.productPoll}>
      <ProgressBar current='4' />
      <NavPanel onClick={onPreviousPageClick} />
      <NavPanel position='right' onClick={onNextPageClick} />


      <div className={styles.pageHeading}>
        <NBLogo onClick={onLogoClick}/>
        <div className={ `${styles.question} ${fortressGrow || prodigyGrow ? styles.prodigyHiding : ''}` } >  
          Which best fits your game?
        </div>
      </div>

      <div className={styles.cards}>
        <div className={ `${styles.card} ${fortressGrow ? styles.fortressMoving : ''} ${prodigyGrow ? styles.prodigyHiding : ''}`  } onClick={onClickFortress} >
          <img
            src='fortress.jpg'
            className={`${styles.productImg} ${fortressGrow ? styles.imgMoving  : ''}`}
          />
          <div className={fortressGrow ? styles.hidden : styles.productName}> Fortress</div>
        </div>

        <div className={ `${styles.card} ${prodigyGrow ? styles.prodigyMoving : ''} ${fortressGrow ? styles.fortressHiding : ''}` } onClick={onClickProdigy}>
          <img
            src='prodigy.jpg'
            className={ `${styles.productImg} ${prodigyGrow ? styles.imgMoving : ''}`}
          />
          <div className={prodigyGrow ? styles.hidden : styles.productName}> Prodigy</div>
        </div>
      </div>

      <Popup visible={popupVisible} onHide={() => setPopupVisible(false)}>
        Redirects to New Balance website.
      </Popup>
    </div>
  );
};

export default ProductPoll; 